import {
    AHOC_INCIDENT_DETAILS_SET_VALUE,
    AHOC_INCIDENT_DETAILS_SET_VALID,
    AHOC_FORM_INVALID_TRANSITION_INCIDENT_DETAILS,
    AHOC_FORM_VALID_TRANSITION_INCIDENT_DETAILS,
} from '../../actions/allsureHomeClaim/incidentDetails';
import { INCIDENT_DEATAILS_LABELS, RADIO_OPTION } from '../../actions/allsureHomeClaim/types';
import { FIELD_STATUS, FORM_STATUS, TOGGLE_STATUS } from '../status';

const calculateDaysFromDate = (incidentDate) => {
    const [day, month, year] = incidentDate.split('/').map(Number);
    const incident = new Date(year, month - 1, day);
    const currentDate = new Date();
    const timeDiff = currentDate - incident;
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return days;
}
export const initIncidentDetails = {
    formStatus: FORM_STATUS.INVALID,
    form: {
        dateOfIncident: { value: null, error: null, status: null, displayValue: null },
        reasonForDelay: { value: null, error: null, status: null, displayValue: null, 
            dependentValue: '',
            dependentField: 'dateOfIncident',
            validationCondition: (currentfield, dependentField) => (dependentField.value && (calculateDaysFromDate(dependentField.value)) >= 30),
        },
        timeOfIncident: { value: null, error: null, status: null, displayValue: null },
        addressOrLocation: { value: null, error: null, status: null, displayValue: null },
        insuredValue: { value: null, error: null, status: null, displayValue: null },
        dateValued: { value: null, error: null,  status: FIELD_STATUS.VALID, displayValue: null },
        lossOccurredDescription: { value: null, error: null, status: null, displayValue: null },
        occupiedAtTimeOfLoss: { value: null, error: null, status: null, displayValue: null },
        burglarAlarmActivated: { value: null, error: null, status: null, displayValue: null },
        damageOccuredPreviously: { value: null, error: null, status: null, displayValue: null },
        damageOccuredPreviouslyDescription: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'damageOccuredPreviously',
        },
        insurerName: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'damageOccuredPreviously',
        },
        thirdPartyReponsilbile: { value: null, error: null, status: null, displayValue: null },
        thirdPartyName: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'thirdPartyReponsilbile',
        },
        thirdPartyContactNumber: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'thirdPartyReponsilbile',
        },
        thirdPartyAddress: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'thirdPartyReponsilbile',
        },
        thirdPartyEmail: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'thirdPartyReponsilbile',
        },
        personTobeKeptInformed: { value: null, error: null,  status: FIELD_STATUS.VALID, displayValue: null },
        personsFullName: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: null,
            dependentField: 'personTobeKeptInformed',
            validationCondition: (currentfield, dependentField) =>
                ['Family', 'Friends'].includes(dependentField?.value),
        },
        personsContact: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: null,
            dependentField: 'personTobeKeptInformed',
            validationCondition: (currentfield, dependentField) =>
                ['Family', 'Friends'].includes(dependentField?.value),
        },
        personsEmail: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: null,
            dependentField: 'personTobeKeptInformed',
            validationCondition: (currentfield, dependentField) =>
                ['Family', 'Friends'].includes(dependentField?.value),
        },
    },
};
export default (state = initIncidentDetails, action) => {
    const trimField = (value) => (value ? value.trim() : value);
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    // if ( CLAIMENT_DETAILS_SET_VALUE) {
    switch (action.type) {
        case AHOC_FORM_VALID_TRANSITION_INCIDENT_DETAILS:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case AHOC_FORM_INVALID_TRANSITION_INCIDENT_DETAILS:
            return { ...state, formStatus: FORM_STATUS.INVALID };
        case AHOC_INCIDENT_DETAILS_SET_VALUE:
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                displayValue: action.value.displayValue ?? action.value.value,
                value: action.value.value,
            }));

        case AHOC_INCIDENT_DETAILS_SET_VALID:
            const { fieldType, error } = action;
            return updateFormField(fieldType, (field) => ({
                ...field,
                error: error,
                status: mapError(error),
            }));

        default:
            return state;
        // }
    }
};
